
import { ConfigTableconstant } from "./ConfigTableConstant";

const ConfigTableAction = {};

ConfigTableAction.getConfigTable = (payload) => {
   
    return {
        type: ConfigTableconstant.CONFIG_TABLE_SAGA, 
        payload:payload
    }
};

ConfigTableAction.UdateConfigCancelAction = (payload) => {
    
    return {
        type: ConfigTableconstant.CONFIG_UPDATE_CANCEL_SAGA,
        payload:payload
    }
};

export { ConfigTableAction };